export default {
  controls: [
    {
      title: 'special.controls.controls',
      icon: 'icon-iboard',
      controlPanel: 'iboard'
    }
  ]
}
